module.exports = __webpack_public_path__ + "static/media/tenantloan.90481c07.svg";